module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/main_img_01-3-c81026b3797fa0e8240f73587da9c4d2.png";